// import * as Sentry from '@sentry/react';
import {QueryCache, QueryClient} from 'react-query';
import {toast} from 'react-toastify';
// import {init as initApm} from '@elastic/apm-rum';

export const initializeServices = () => {
  // const isLoggedIn = !!localStorage.getItem('user:token');
  const authDetails = JSON.parse(localStorage.getItem('state'))?.auth;
  const user = authDetails?.user;
  const rest = authDetails?.userDetails;
  const fullName = (user && `${user?.first_name} ${user?.last_name}`) || '-';
  const userId = (user && user?.id) || '-';
  const userEmail = (user && user?.email) || '-';
  const userCompany = rest?.company?.name || '-';

  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (query) {
          const meta = query.options?.meta || null;
          if ('preventGlobalError' in meta && meta.preventGlobalError) {
            return;
          }
          if (error.response && error.response.status === 500) {
            toast.error('Ops! Internal Server Error');
          } else {
            toast.error(error.response?.data?.error);
          }
        }
      },
    }),
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 2000,
      },
    },
  });

  if (typeof window !== 'undefined') {
    ////////////////// Initialize the APM /////////////////////////
    // initApm({
    //   serviceName: 'dojah-app',
    //   // serverUrl: 'http://apm-apm-server:8200',
    //   serverUrl: ['staging', 'development'].includes(
    //     process.env.REACT_APP_APP_ENV_MODE,
    //   )
    //     ? 'http://apm-apm-server.logging.svc.cluster.local:8200'
    //     : 'https://apm.dojah.services',
    //   // : 'http://apm-apm-server.logging.svc.cluster.local:8200',

    //   serviceVersion: '',
    //   environment: process.env.REACT_APP_APP_ENV_MODE,
    // });

    /////////////// Initialize the Sentry agent ///////////////////
    // Sentry.init({
    //   dsn: process.env.REACT_APP_SENTRY_DSN,
    //   tracesSampleRate:
    //     process.env.REACT_APP_APP_ENV_MODE === 'production' ? 0.1 : 0.6,
    //   environment: process.env.REACT_APP_APP_ENV_MODE,
    //   replaysSessionSampleRate: 1.0,
    //   replaysOnErrorSampleRate: 1.0,
    //   integrations: [
    //     new Sentry.BrowserTracing({tracingOrigins: ['*']}),
    //     new Sentry.Replay({
    //       beforeAddRecordingEvent: event => {
    //         if (!isLoggedIn && !user) {
    //           return null;
    //         }
    //         if (user) {
    //           event.user = {
    //             id: userId,
    //             email: userEmail,
    //             username: fullName,
    //           };
    //         }
    //         return event;
    //       },
    //       maskAllText: false,
    //       blockAllMedia: false,
    //     }),
    //   ],
    //   ignoreErrors: [
    //     // Ignore specific error messages
    //     'ChunkLoadError',
    //     'TypeError',
    //     'Loading chunk failed',
    //     'Network Error',
    //     // Regex patterns
    //     /failed to fetch/i,
    //     /\$\$pdfmake\$\$1/i,
    //     /Failed to load Stripe.js/i,
    //     /loading chunk \d+ failed/i,
    //   ],
    // });

    // Sentry.setUser({
    //   id: userId,
    //   username: fullName,
    //   email: userEmail,
    //   company: userCompany,
    // });

    ////////////////// Initialize Microsoft Clarity /////////////////////////
    if (window.clarity) {
      window.clarity('identify', user?.id || 'USER_ID', {
        firstName: user?.first_name || '',
        lastName: user?.last_name || '',
        email: user?.email || '',
        fullName: fullName,
        company: userCompany,
      });
    }
  }

  return {queryClient};
};
